'use strict';

exports.__esModule = true;

var _kindergarten = require('kindergarten');

exports.default = function (governess) {
  if (!governess) return new _kindergarten.HeadGoverness();

  if (!(0, _kindergarten.isGoverness)(governess)) {
    throw new _kindergarten.ArgumentError('Governess must be instance of HeadGoverness.');
  }

  return governess;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-kindergarten/lib/vue-kindergarten/getGoverness.js
// module id = EE9R
// module chunks = 40